export type EditorRole =
	| 'heading'
	| 'text'
	| 'body'
	| 'section'
	| 'img'
	| 'btn';

export const EDITOR_ROLES = new Set<EditorRole>([
	'heading',
	'text',
	'body',
	'section',
	'img',
	'btn',
]);

export type EditableDescriptor = {
	id: string; // "bw-<role>-<uid>"
	role: EditorRole;
	uid: string;
};

export type EditorSelection = {
	descriptor: EditableDescriptor;
	anchorRect: DOMRect;
	/** False once the anchored element has scrolled out of the email frame. */
	isAnchorVisible: boolean;
	/** The email frame's page box, which bounds where the panel may draw. */
	frameRect: DOMRect;
};

export type EditPatch = {
	textContent: string;
	backgroundColor: string;
	textColor: string;
	borderColor: string;
	src: string;
	href: string;
};

export type LabelDiagnostics = {
	labeledCount: number;
	skippedMalformedLabels: number;
	duplicateIdsDetected: number;
};

export type InlineEmailEditorProps = {
	html: string;
	brandColors?: string[] | null;
	brandImages?: { display_url: string }[] | null;
	onHtmlChange?: (html: string) => void;
	onDiagnosticsChange?: (diagnostics: LabelDiagnostics) => void;
};
